import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { IframeAuthService } from '../../shared/services/iframe-auth.service';

export const iframeAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(IframeAuthService);

  // Solo actuar si estamos en un contexto de iframe y hemos recibido datos del usuario
  if (window.parent !== window && authService.hasReceivedAuthData()) {
    const token = authService.getToken();

    if (token) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
      return next(authReq);
    }
  }

  return next(req);
};
